module.exports = __webpack_public_path__ + "static/Remote Control-363ab0fd62d6722c7832badd3892f3bb.png";